export const downloadPdf = (content, filename) => {
    const blob = new Blob([content]);
    const link = window.document.createElement('a');
    link.download = filename;
    link.href = window.URL.createObjectURL(blob);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
